import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function AdminMesas() {
  const [mesas, setMesas] = useState([]);
  const [editando, setEditando] = useState(null);
  const [novo, setNovo] = useState({ numero: '', descricao: '', ordem: 0 });
  const [mostrarForm, setMostrarForm] = useState(false);
  const [toast, setToast] = useState('');

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  const carregar = async () => {
    try {
      const r = await api.get('/mesas/admin');
      setMesas(r.data);
    } catch { showToast('❌ Erro ao carregar'); }
  };

  useEffect(() => { carregar(); }, []);

  const salvarNovo = async () => {
    if (!novo.numero) return showToast('⚠️ Número obrigatório');
    try {
      await api.post('/mesas', novo);
      setNovo({ numero: '', descricao: '', ordem: 0 });
      setMostrarForm(false);
      showToast('✅ Mesa cadastrada!');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const salvarEdicao = async () => {
    try {
      await api.put(`/mesas/${editando.id}`, editando);
      setEditando(null);
      showToast('✅ Atualizada!');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const desativar = async (m) => {
    if (!window.confirm(`Desativar "${m.numero}"?`)) return;
    try {
      await api.delete(`/mesas/${m.id}`);
      showToast('✅ Desativada');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const inputStyle = {
    background: 'var(--bg4)', border: '1px solid var(--border)',
    color: 'var(--text)', padding: '8px 10px', borderRadius: 6,
    fontSize: 13, width: '100%'
  };

  const btnStyle = {
    background: 'var(--orange)', border: 'none', color: '#fff',
    padding: '8px 14px', borderRadius: 6, cursor: 'pointer',
    fontSize: 13, fontWeight: 600
  };

  return (
    <div style={{ padding: 16, maxWidth: 700, margin: '0 auto' }}>
      {toast && <div style={{
        position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)',
        background: 'linear-gradient(90deg,var(--red),var(--orange))',
        color: '#fff', padding: '10px 20px', borderRadius: 20,
        fontSize: 13, fontWeight: 700, zIndex: 999
      }}>{toast}</div>}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800 }}>🍽️ Mesas</h1>
        <button onClick={() => setMostrarForm(!mostrarForm)} style={btnStyle}>
          {mostrarForm ? '✕ Fechar' : '+ Nova'}
        </button>
      </div>

      {mostrarForm && (
        <div style={{ background: 'var(--bg3)', padding: 16, borderRadius: 8, marginBottom: 16, border: '1px solid var(--border)' }}>
          <h3 style={{ marginBottom: 12, fontSize: 15 }}>Nova Mesa</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 100px', gap: 10, marginBottom: 10 }}>
            <input placeholder='Nº ou nome (ex: 3, Balcão)' value={novo.numero} onChange={e => setNovo({ ...novo, numero: e.target.value })} style={inputStyle} />
            <input placeholder="Descrição (opcional)" value={novo.descricao} onChange={e => setNovo({ ...novo, descricao: e.target.value })} style={inputStyle} />
            <input type="number" placeholder="Ordem" value={novo.ordem} onChange={e => setNovo({ ...novo, ordem: parseInt(e.target.value) || 0 })} style={inputStyle} />
          </div>
          <button onClick={salvarNovo} style={{ ...btnStyle, width: '100%' }}>💾 Cadastrar</button>
        </div>
      )}

      {mesas.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>Nenhuma mesa cadastrada</div>
      ) : mesas.map(m => (
        <div key={m.id} style={{
          background: 'var(--bg3)', padding: 14, borderRadius: 8,
          marginBottom: 10, border: '1px solid var(--border)',
          opacity: m.ativo ? 1 : 0.5
        }}>
          {editando?.id === m.id ? (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 100px', gap: 10, marginBottom: 10 }}>
                <input value={editando.numero} onChange={e => setEditando({ ...editando, numero: e.target.value })} style={inputStyle} />
                <input value={editando.descricao || ''} onChange={e => setEditando({ ...editando, descricao: e.target.value })} style={inputStyle} placeholder="Descrição" />
                <input type="number" value={editando.ordem || 0} onChange={e => setEditando({ ...editando, ordem: parseInt(e.target.value) || 0 })} style={inputStyle} />
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10, fontSize: 13 }}>
                <input type="checkbox" checked={!!editando.ativo} onChange={e => setEditando({ ...editando, ativo: e.target.checked ? 1 : 0 })} />
                Ativa
              </label>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={salvarEdicao} style={{ ...btnStyle, background: '#22c55e' }}>💾 Salvar</button>
                <button onClick={() => setEditando(null)} style={{ ...btnStyle, background: 'var(--bg4)' }}>Cancelar</button>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 15, fontWeight: 700 }}>
                  {m.numero.match(/^\d+$/) ? `Mesa ${m.numero}` : m.numero}
                  {!m.ativo && ' (inativa)'}
                </div>
                {m.descricao && <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>{m.descricao}</div>}
                <div style={{ fontSize: 11, color: 'var(--text2)', marginTop: 2 }}>Ordem: {m.ordem}</div>
              </div>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => setEditando({ ...m })} style={{ ...btnStyle, fontSize: 12, padding: '6px 10px' }}>✏️</button>
                {m.ativo === 1 && (
                  <button onClick={() => desativar(m)} style={{ ...btnStyle, background: 'var(--red)', fontSize: 12, padding: '6px 10px' }}>🚫</button>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
